import { atom } from 'jotai';

export type ValidationCodeAtom = {
  /**
   * The access token, which is used in the postProductOrder with the validation code
   */
  accessToken: string;
} | null;

export const validationCodeInitialValue: ValidationCodeAtom = null;

export const validationCodeAtom = atom<ValidationCodeAtom>(validationCodeInitialValue);
